import { queryOptions } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const creatorsDefinePlatformQueryOptions = (companyId: string, gameId: string, url: string) =>
  queryOptions({
    queryKey: ['creators-define-platform', companyId, gameId, url],
    queryFn: () => dashboardClient.v1.defineCreatorPlatform({ companyId, gameId, url }),
    select: response => response.data,
    staleTime: 60000,
  })
